import { useDashboardShareActions } from '#src/app/pages/starterDashboardV2/shared/hooks';

import { SUPPORTED_CHANNELS } from '../../constants';
import { isSupportedChannelAction } from '../../helpers';
import type { SupportedChannelShareAction } from '../../types';

const customTrackingData = [
	{ context: 'petition_dashboard_share_online', view_context: 'petition_dashboard_share_online' },
];

export function useShareSocial(): SupportedChannelShareAction[] {
	const actions = useDashboardShareActions(undefined, undefined, customTrackingData);

	// For the reskin, we only want to show a subset of channels and in a specific order
	return actions
		.slice()
		.sort((a, b) => SUPPORTED_CHANNELS.indexOf(a.channel) - SUPPORTED_CHANNELS.indexOf(b.channel))
		.filter(isSupportedChannelAction);
}
